export default {
    equal: 'equal',
    notEqual: 'notEqual',
    lessThan: 'lessThan',
    lessThanOrEqual: 'lessThanOrEqual',
    greaterThan: 'greaterThan',
    greaterThanOrEqual: 'greaterThanOrEqual',
};
